import { Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";

export default function AddNewReportModal({ open, setOpen, setPreviewReportDetails }) {
  const [selectedReportType, setSelectedReportType] = useState<string | null>(null);

  const handleRadioChange = (value: string) => {
    setSelectedReportType(value);
  };
  return (
    <Dialog open={open} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
      <DialogTitle className="dialog-title">
        <div className="heading-m"> Add New Report</div>
        <div className="vertical_center_align">
          <IconButton onClick={() => setOpen(false)}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 2 }}>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 400, fontSize: "16px", letterSpacing: "0.15px", lineHeight: "175%" }}
          >
            Choose the type of report you want to add
          </Typography>
          <List>
            {["Funnel", "Status"].map((reportName) => (
              <ListItem key={reportName} sx={{ paddingY: "8px", alignItems: "flex-start" }}>
                <ListItemIcon>
                  <Radio checked={selectedReportType === reportName} onChange={() => handleRadioChange(reportName)} />
                </ListItemIcon>
                <ListItemText
                  primary={`${reportName} Report`}
                  secondary={
                    reportName === "Status"
                      ? "Summary at task's status level with multiple data points, like count of partners, own CB, CB difference, avg ageing."
                      : "Funnel view of your task's activities done. From sending mails till recon done with recon gap summary."
                  }
                  primaryTypographyProps={{
                    sx: {
                      fontWeight: 400,
                      fontSize: "16px",
                      letterSpacing: "0.15px",
                      lineHeight: "150%",
                    },
                  }}
                  secondaryTypographyProps={{
                    sx: {
                      fontWeight: 400,
                      fontSize: "14px",
                      letterSpacing: "0.17px",
                      lineHeight: "143%",
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <CustomButton
          size="medium"
          colorToken="violet"
          variant="contained"
          disabled={selectedReportType === null}
          onClick={() => {
            setPreviewReportDetails({
              id: null,
              reportType: selectedReportType && selectedReportType.toLowerCase(),
              reportAction: "addReport",
            });
            setOpen(false);
          }}
        >
          Next
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
}
